import React, { useEffect } from "react";
import Header from "../Templete/Header";
import Footer from "../Templete/Footer";

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "Privacy Policy | FORMAX MONEY";
  }, []);

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>
            Your privacy matters. Learn how we protect and manage your data in
            compliance with Indian laws and RBI guidelines for Business
            Correspondents.
          </p>
        </div>
      </section>

      <div className="container">
        <div className="privacy-content">
          <div className="privacy-card">
            <h2>1. Introduction & Consent</h2>
            <p>
              FORMAX MONEY (operated by{" "}
              <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong>) respects
              your privacy. This Privacy Policy explains how we collect, use,
              disclose, and safeguard your information when you use our website,
              mobile application, or services (collectively, the "Services") as
              a Corporate Business Correspondent.
            </p>
            <p>
              By accessing or using our Services, you consent to the practices
              described in this policy. If you do not agree, please do not use
              our Services.
            </p>
          </div>

          <div className="privacy-card">
            <h2>2. Information We Collect</h2>
            <p>
              To provide you with financial inclusion and BC Agent services, we
              may collect the following categories of personal information:
            </p>
            <ul>
              <li>
                <strong>Identity & Contact Data:</strong> Name, email address,
                mobile number, PAN Card, Aadhaar Card, date of birth, and
                correspondence address for KYC compliance.
              </li>
              <li>
                <strong>Business & Shop Data:</strong> Shop address, shop
                photographs, business registration proof, and physical
                verification records.
              </li>
              <li>
                <strong>Transaction Data:</strong> Details of AEPS, DMT, CMS,
                UPI Cash Point transactions, amounts, timestamps, beneficiary
                details, and transaction status.
              </li>
              <li>
                <strong>Bank Account Information:</strong> Bank account details
                for commission settlements and transaction processing.
              </li>
              <li>
                <strong>Technical & Usage Data:</strong> IP address, browser
                type, device identifiers, operating system, and browsing actions
                on our platform.
              </li>
              <li>
                <strong>Communication Data:</strong> Records of your
                interactions with our customer support team (calls, emails,
                chats).
              </li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>3. Legal Basis for Processing (Indian Compliance)</h2>
            <p>
              Under Indian law and RBI guidelines for Business Correspondents,
              we process your personal information based on:
            </p>
            <ul>
              <li>
                <strong>Consent:</strong> You have provided explicit consent for
                specific purposes.
              </li>
              <li>
                <strong>Contractual Necessity:</strong> To perform the services
                you request (BC Agent onboarding, financial transactions).
              </li>
              <li>
                <strong>Legal Obligation:</strong> To comply with applicable
                laws including KYC norms, PMLA, and RBI directives.
              </li>
              <li>
                <strong>Legitimate Interests:</strong> To prevent fraud, ensure
                security, and maintain regulatory compliance.
              </li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>4. How We Use Your Information</h2>
            <p>
              We use your personal information only for legitimate business
              purposes:
            </p>
            <ul>
              <li>Process BC Agent registration and KYC verification.</li>
              <li>
                Conduct physical and shop verification as per bank guidelines.
              </li>
              <li>
                Process financial transactions including AEPS, DMT, CMS, and UPI
                Cash Point.
              </li>
              <li>Settle commissions and payouts to BC Agents.</li>
              <li>
                Send transaction confirmations, alerts, and service updates.
              </li>
              <li>
                Respond to your queries, complaints, and support requests.
              </li>
              <li>
                Detect and prevent fraudulent, unauthorised, or illegal
                activities including money laundering.
              </li>
              <li>
                Comply with legal, regulatory, and law enforcement requests.
              </li>
              <li>
                Improve our platform, analyse usage trends, and enhance
                security.
              </li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>5. Data Sharing & Disclosure</h2>
            <p>
              We do not sell, rent, or trade your personal information. However,
              we may share your data with:
            </p>
            <ul>
              <li>
                <strong>Partner Banks:</strong> For KYC verification,
                transaction processing, and regulatory compliance.
              </li>
              <li>
                <strong>Service Providers:</strong> NPCI, payment gateways, and
                technology partners – only to fulfil your transactions.
              </li>
              <li>
                <strong>Government & Law Enforcement:</strong> When required by
                law, court order, or governmental authority (e.g., under the IT
                Act, 2000, PMLA).
              </li>
              <li>
                <strong>Regulatory Bodies:</strong> RBI, Income Tax Department,
                and other statutory authorities as mandated.
              </li>
              <li>
                <strong>Business Transfers:</strong> In case of merger,
                acquisition, or asset sale, your information may be transferred
                with prior notice.
              </li>
            </ul>
            <p>
              All third parties are contractually bound to protect your data and
              use it only for the specified purposes.
            </p>
          </div>

          <div className="privacy-card">
            <h2>6. Data Security & Retention</h2>
            <p>
              We implement industry-standard security measures, including SSL
              encryption, firewalls, role-based access controls, and regular
              security audits to protect your personal information from
              unauthorised access, alteration, or destruction.
            </p>
            <p>
              We retain your personal information only as long as necessary to
              fulfil the purposes outlined in this policy, comply with legal
              obligations, resolve disputes, and enforce our agreements.
              Typically, transaction and KYC data is retained for{" "}
              <strong>7-10 years</strong> as required by Indian tax laws and RBI
              guidelines.
            </p>
          </div>

          <div className="privacy-card">
            <h2>7. Cookies & Tracking Technologies</h2>
            <p>
              We use cookies, web beacons, and similar technologies to enhance
              your browsing experience, analyse traffic, and remember
              preferences. You can control cookies through your browser
              settings. Disabling cookies may affect certain features of our
              website.
            </p>
            <p>
              <strong>Types of cookies we use:</strong> Essential (for website
              functionality), Performance (analytics), Functional (preferences),
              and Security (fraud prevention).
            </p>
          </div>

          <div className="privacy-card">
            <h2>8. Your Rights (Under Indian Law)</h2>
            <p>As a user in India, you have the following rights:</p>
            <ul>
              <li>
                <strong>Right to Access:</strong> Request a copy of your
                personal information we hold.
              </li>
              <li>
                <strong>Right to Correction:</strong> Update or correct
                inaccurate data.
              </li>
              <li>
                <strong>Right to Withdraw Consent:</strong> Withdraw consent for
                processing (where consent is the basis).
              </li>
              <li>
                <strong>Right to Data Portability:</strong> Receive your data in
                a structured format.
              </li>
              <li>
                <strong>Right to Grievance Redressal:</strong> Lodge a complaint
                with our Grievance Officer (see Section 12).
              </li>
            </ul>
            <p>
              To exercise these rights, contact us at{" "}
              <strong>support@formaxmoney.in</strong>. We will respond within 30
              days as mandated by law.
            </p>
          </div>

          <div className="privacy-card">
            <h2>9. Cross-Border Data Transfer</h2>
            <p>
              Your personal information is primarily stored on servers located
              in India. We do not transfer sensitive personal data outside India
              without your explicit consent and adequate safeguards as required
              by the SPDI Rules and DPDP Act.
            </p>
          </div>

          <div className="privacy-card">
            <h2>10. Children's Privacy</h2>
            <p>
              Our Services are not intended for individuals under the age of 18.
              We do not knowingly collect personal information from minors. If
              we become aware that a minor has provided us with personal data,
              we will delete it immediately. Parents or guardians may contact us
              to report such instances.
            </p>
          </div>

          <div className="privacy-card">
            <h2>11. BC Agent Specific Provisions</h2>
            <p>
              As a BC Agent registered with FORMAX MONEY, additional privacy
              provisions apply:
            </p>
            <ul>
              <li>
                Your KYC documents will be shared with partner banks for
                verification and compliance.
              </li>
              <li>
                Transaction data of your customers may be monitored for fraud
                detection and regulatory reporting.
              </li>
              <li>
                Physical verification data (shop photos, location) will be
                stored securely and shared only with partner banks.
              </li>
              <li>
                You are responsible for maintaining privacy of customer data as
                per applicable laws.
              </li>
            </ul>
          </div>

          <div className="privacy-card">
            <h2>12. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time to reflect
              changes in our practices, technology, or legal requirements.
              Significant changes will be notified via email or a prominent
              notice on our website.
            </p>
          </div>

          <div className="privacy-card">
            <h2>13. Grievance Officer (Nodal Contact Person)</h2>
            <p>
              In compliance with Rule 5(9) of the Information Technology
              (Reasonable Security Practices and Procedures and Sensitive
              Personal Data or Information) Rules, 2011, and RBI guidelines, the
              Grievance Officer for data protection matters is:
            </p>
            <p>
              <strong>Name:</strong> Mr. Ezazul Haque (Compliance Officer)
              <br />
              <strong>Email:</strong> grievance@formaxmoney.in
              <br />
              <strong>Phone:</strong> +91 7890090500
              <br />
              <strong>Address:</strong> N0060, Mochpole, Near Junior School,
              Nabapally, Barasat, Kolkata - 700126, West Bengal, India
            </p>
            <p>
              Any complaints or concerns regarding data handling should be sent
              to the Grievance Officer. We will acknowledge your complaint
              within 24 hours and endeavour to resolve it within one month.
            </p>
          </div>

          <div className="privacy-card">
            <h2>14. Contact Us</h2>
            <p>
              For any questions about this Privacy Policy or your data, please
              contact:
            </p>
            <p>
              <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong>
              <br />
              N0060, Mochpole, Near Junior School, Nabapally, Barasat,
              <br />
              Kolkata - 700126, West Bengal, India
              <br />
              Email: support@formaxmoney.in
              <br />
              Phone: +91 7890090500
              <br />
              Website: www.formaxmoney.in
            </p>
          </div>
        </div>
      </div>

      <Footer />

      <style>{`
        .page-hero {
          background: linear-gradient(135deg, #0A2540 0%, #1A3A5F 100%);
          padding: 60px 0 70px;
          text-align: center;
        }
        .page-hero h1 {
          font-size: 2.8rem;
          margin-bottom: 16px;
          color: white;
          font-weight: 700;
        }
        .page-hero p {
          color: rgba(255,255,255,0.85);
          max-width: 700px;
          margin: 0 auto;
          font-size: 1.1rem;
        }
        
        .privacy-content {
          margin: 60px 0;
        }
        
        .privacy-card {
          background: white;
          border-radius: 28px;
          padding: 32px;
          margin-bottom: 30px;
          box-shadow: 0 10px 25px -5px rgba(0,0,0,0.05);
          border: 1px solid #eef2ff;
          transition: all 0.3s ease;
        }
        
        .privacy-card:hover {
          border-color: rgba(212, 175, 55, 0.3);
          box-shadow: 0 15px 30px -10px rgba(0,0,0,0.1);
        }
        
        .privacy-card h2 {
          font-size: 1.6rem;
          margin-bottom: 16px;
          color: #0A2540;
          font-weight: 700;
        }
        
        .privacy-card p {
          margin-bottom: 16px;
          line-height: 1.6;
          color: #475569;
        }
        
        .privacy-card ul {
          margin-left: 24px;
          margin-bottom: 8px;
        }
        
        .privacy-card li {
          margin-bottom: 10px;
          line-height: 1.5;
          color: #475569;
        }
        
        .privacy-card a {
          color: #D4AF37;
          text-decoration: none;
        }
        
        .privacy-card a:hover {
          text-decoration: underline;
        }
        
        @media (max-width: 768px) {
          .page-hero {
            padding: 40px 0 50px;
          }
          .page-hero h1 { 
            font-size: 2rem; 
          }
          .page-hero p {
            font-size: 1rem;
            padding: 0 20px;
          }
          .privacy-card h2 { 
            font-size: 1.3rem; 
          }
          .privacy-card { 
            padding: 24px; 
          }
        }
        
        @media (max-width: 576px) {
          .privacy-card ul {
            margin-left: 16px;
          }
        }
      `}</style>
    </>
  );
};

export default PrivacyPolicy;
